export const getPublicPageUrl = (subdomain, slug) => {
  const protocol = window.location.protocol;
  const host = window.location.host;
  const isSubdomain = host.split('.').length > 2;

  if (isSubdomain) {
    // We're already on a subdomain, just use the path
    return `/${slug || ''}`;
  } else {
    // We're on the main domain, use the /sites/ path
    return `/sites/${subdomain}/${slug || ''}`;
  }
};

export const getApiUrl = (path) => {
  const protocol = window.location.protocol;
  const host = window.location.host;
  return `${protocol}//${host}${path}`;
}; 